import { Stack } from "@mui/material";
import {
    TableEntryIcon,
    TableEntryLabel,
    TableEntryValue,
} from "src/components/cards/senec-tile/table-card-content/TableCardElements";
import { TableCardContentProps, TableCardEntry } from "src/components/cards/senec-tile/dataTypes";
import { dataHasIcons } from "src/components/cards/senec-tile/table-card-content/tableCardUtils";

export const StackedCardContent = ({
    data,
    highlightLabel,
    hasIconPlaceholderSpacing = false,
}: TableCardContentProps & { hasIconPlaceholderSpacing?: boolean }) => {
    const placeholderSpacing = hasIconPlaceholderSpacing || dataHasIcons(data);

    return (
        <Stack spacing={2}>
            {data.map((entry: TableCardEntry, index) => (
                <StackedCardContentEntry
                    key={"stacked-card-entry-" + index}
                    data={entry}
                    hasIconPlaceholderSpacing={placeholderSpacing}
                    highlightLabel={highlightLabel}
                />
            ))}
        </Stack>
    );
};

const StackedCardContentEntry = ({
    data,
    hasIconPlaceholderSpacing,
    highlightLabel,
}: {
    data: TableCardEntry;
    hasIconPlaceholderSpacing: boolean;
    highlightLabel?: boolean;
}) => {
    return (
        <Stack
            data-testid="content-row"
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            spacing={1}
            sx={{
                position: "relative",
                width: "100%",
            }}
        >
            <Stack spacing="4px" flexGrow={1}>
                <TableEntryLabel data={data} highlightLabel={highlightLabel} applyColor={false} />
                <TableEntryValue data={data} highlightLabel={highlightLabel} />
            </Stack>
            <TableEntryIcon data={data} hasPlaceholderSpacing={hasIconPlaceholderSpacing} />
        </Stack>
    );
};
